import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

type PropsType = {
  id?: any;
  petName?: any;
  date?: string;
  riskLevel?: string;
  riskValue?: any;
  result?: any;
};

const UserLabResultMobile = ({ id, petName, date, riskLevel, riskValue, result }: PropsType) => {
  const reportDownloadHandler = () => {
    const fileUrl = result.file;

    // Option 1: Using window.open (this opens the file in a new tab)
    window.open(fileUrl, "_blank");
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  const dateConversion = (dateStr: any) => {
    const dateObj = new Date(dateStr);

    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear().toString();

    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  return (
    <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
      <div className="tw-w-[80%] tw-mx-auto tw-flex tw-flex-col tw-gap-3">
        {/* 1st main col */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          {/* 1st col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">My Pets</span>
            <span className=""> {petName?.petName && petName?.petName !== "" ? petName?.petName : "None"}</span>
          </div>

          {/* 2nd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">Activation Date</span>
            <span className="tw-text-start"> {date ? dateConversion(date) : "None"}</span>
          </div>
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">Activation Code</span>
            <span className="">{result?.kitId?.code}</span>
          </div>

          {/* 3rd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">Risk Level</span>
            <span className="">{riskLevel ? riskLevel : "Pending"}</span>
          </div>
        </div>
        {/* 2nd main col */}
        <div className="tw-w-[80%] tw-mx-auto tw-flex tw-flex-col tw-gap-1 tw-items-center tw-justify-center">
          <span className="tw-font-bold tw-text-base tw-text-darkPurple">Test Result</span>
          {result.submit ? (
            <button
              className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
              onClick={() => reportDownloadHandler()}
            >
              Download
            </button>
          ) : (
            <button className="tw-flex tw-items-center tw-justify-center tw-text-lg  tw-font-bold tw-bg-[transparent] tw-border tw-text-[#FF7B6D] tw-border-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md">
              Pending
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLabResultMobile;
